import { LoginCard } from '~/ComponentsTW/layout/login-card';
import { Button, Form, FormInput, FormLabel, PasswordInput, StandaloneLink } from '~/ComponentsTW/wm';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { apiRequest } from 'utils/request';

export function LoginForm({ onOtpRequest, onAlert, onForgotPassword }) {
    const
        [email, setEmail] = useState(''),
        [formFilled, setFormFilled] = useState(false),
        [loading, setLoading] = useState(false),
        [password, setPassword] = useState('');

    useEffect(() => {
        const formFilled = password !== '' && email !== '';

        setFormFilled(formFilled);
    }, [email, password]);

    const handleForgotPassword = () => {
        onForgotPassword(email);
    };

    const handleSubmit = async event => {
        event.preventDefault();
        setLoading(true);

        const data = {
            email,
            password
        };

        try {
            const response = await apiRequest('/login', 'POST', data);

            if (response.status === 200) {
                onOtpRequest(email, password);
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error || 'An error occurred';

            onAlert(errorMessage, 'destructive', 'Failed');
            setPassword('');
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    return (
        <LoginCard>
            <Form>
                <FormLabel htmlFor="email">email</FormLabel>
                <FormInput
                    id="email"
                    onChange={e => setEmail(e.target.value)}
                    placeholder="m@example.com"
                    required
                    type="email"
                    value={email}
                />
                <FormLabel htmlFor="password">password</FormLabel>
                <PasswordInput
                    id="password"
                    onChange={e => setPassword(e.target.value)}
                    required
                    value={password}
                />
                <Button className="tw-w-full" disabled={!formFilled} loading={loading} onClick={handleSubmit} type="submit" variant="secondary">
                    Login
                </Button>
            </Form>
            <div className="tw-flex tw-justify-between tw-gap-2">
                <StandaloneLink onAction={handleForgotPassword} text="Forgot password?"/>
                <StandaloneLink href="mailto:support@wisemetering.com" text="Contact us"/>
            </div>
        </LoginCard>
    );
}
